import React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box, InputLabel } from "@mui/material";
import ArrowDownIcon from "../../assets/icon/arrow-down";
import { useSelector } from "react-redux";
import { getMode } from "../../redux/layoutSlice";

export default function Selector({
  label,
  data,
  width,
  withCustomMenuItems,
  fullWidth,
  value,
  disabled,
  sx,
  ...rest
}: any) {
  const mode = useSelector(getMode);
  return (
    <FormControl size="small" sx={{ width: fullWidth ? "100%" : "fit-content" }}>
      {label && (
        <InputLabel
          id="demo-simple-select-label"
          sx={{ fontSize: "14px", fontWeight: "400", color: "#6A7282", lineHeight: "24px" }}
        >
          {label}
        </InputLabel>
      )}
      <Select
        disabled={disabled}
        IconComponent={ArrowDownIcon}
        value={value ?? ""}
        label={label}
        labelId="demo-simple-select-label"
        displayEmpty
        renderValue={(value: any) =>
          withCustomMenuItems ? (
            data.find((item: any) => item?.value === value)?.name
          ) : (
            <Box sx={{ textTransform: "capitalize !important" }}>{value}</Box>
          )
        }
        sx={{
          width: width ? width : "100%",
          minHeight: "24px",
          height: "40px",
          textTransform: "capitalize !important",
          "& .MuiSelect-icon": { width: "16px", stroke: mode === "dark" ? "#fff" : "#020817" },
          "&>.MuiOutlinedInput-input": {
            textTransform: "capitalize !important",
            fontSize: "14px",
            fontWeight: "400",
          },
          "&>.MuiSelect-select": {
            minHeight: "24px !important",
            textTransform: "capitalize !important",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          },

          ...sx,
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: "200px",
              overflowY: "auto",
            },
          },
        }}
        {...rest}
      >
        {withCustomMenuItems
          ? data?.map((item: any, index: number) => (
              <MenuItem
                key={index}
                value={item.value}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  "& > p": { fontSize: "14px" },
                }}
              >
                {item.labelComponent ? item.labelComponent() : item.name}
              </MenuItem>
            ))
          : data?.map((i: any, index: number) => (
              <MenuItem
                key={index}
                value={i}
                sx={{
                  textTransform: "capitalize",
                  fontSize: "14px",
                  "& > p": { fontSize: "14px" },
                }}
              >
                {i}
              </MenuItem>
            ))}
      </Select>
    </FormControl>
  );
}
